import { BaseCalendarModel, BaseCalendarProperties } from './base-calendar.model';
import { MonthOrdinal } from '../../../features/calendar/calendar-types';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';
import { CalendarConfigModel } from '../app-config/calendar-config.model';
import { GlobalAppConfigModel } from '../app-config/global-app-config.model';

export class MonthCalendarModel extends BaseCalendarModel {
  public fixIntervalCalendarModel = new FixIntervalMonthCalendarModel();
  public readonly calendarProperties = new MonthCalendarProperties();

  constructor(calendarOptions?: CalendarConfigModel, globalAppConfigModel?: GlobalAppConfigModel) {
    super();
    if (!calendarOptions) {
      return;
    }
    this.calendarProperties.weekStartsOn = globalAppConfigModel.weekStartsOn;
    const today = new Date();
    this.calendarProperties.month = today.getMonth() as MonthOrdinal;
    this.calendarProperties.year = today.getFullYear();
    this.calendarProperties.days = [];
    this.calendarProperties.workTimeStart = DateTimeHelper.timeStringToDate(
      globalAppConfigModel.workTimeStart,
    );
    this.calendarProperties.workTimeEnd = DateTimeHelper.timeStringToDate(
      globalAppConfigModel.workTimeEnd,
    );
  }
}

class MonthCalendarProperties extends BaseCalendarProperties {}

class FixIntervalMonthCalendarModel extends BaseCalendarModel {}
